import { render, staticRenderFns } from "./GamesEditorView.vue?vue&type=template&id=2b8f319c&"
import script from "./GamesEditorView.vue?vue&type=script&lang=js&"
export * from "./GamesEditorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports